import React from 'react'
import './ContainerTem.scss'
const ContainerTem = (props: any) => {


    return (
        props.intercalar
            ? <div className='container-tem-right'>
                <div className="container-tem-right__img">
                    <img src={props.imagen} alt="" />
                </div>
                <div className="container-tem-right__text">
                    <h3>{props.titulo}</h3>
                    <ul>
                        {props.temas.map((tema: string, idx: number) => <li key={idx}><span></span> <p>{tema}</p></li>)}
                    </ul>
                </div>
            </div>
            : <div className='container-tem-left'>
                <div className="container-tem-left__text">
                    <h3>{props.titulo}</h3>
                    <ul>
                        {props.temas.map((tema: string, idx: number) => <li key={idx}><p>{tema}</p><span></span></li>)}
                    </ul>
                </div>
                <div className="container-tem-left__img">
                    <img src={props.imagen} alt="" />
                </div>
            </div>
    )
}

export default ContainerTem
